import GroupCapacityModal from './GroupCapacityModal';

export default GroupCapacityModal;
